module.exports = __webpack_public_path__ + "static/media/9DESA15.37f6db34.jpg";